module.exports = __webpack_public_path__ + "static/media/ao.d8baa706.svg";